function initTopSellerSwiper() {
    const e = document.querySelector(".top_seller_swiper");
    if (!e) return;
    new IntersectionObserver(
        (r, i) => {
            if (r[0].isIntersecting) {
                const start = () => {
                    if (typeof window.whenSwiperReady !== "function") {
                        setTimeout(start, 50);
                        return;
                    }
                    window.whenSwiperReady(function () {
                        if (e.swiper) return;
                        const count = e.querySelectorAll(".swiper-slide").length;
                        new Swiper(".top_seller_swiper", {
                            loop: count > 4,
                            slidesPerView: 2,
                            spaceBetween: 15,
                            navigation: { prevEl: ".top_seller_swiper_prev", nextEl: ".top_seller_swiper_next" },
                            scrollbar: { el: ".swiper-scrollbar" },
                            breakpoints: {
                                576: { slidesPerView: 1.6 },
                                768: { slidesPerView: 2 },
                                992: { slidesPerView: 3 },
                                1600: { slidesPerView: 4, spaceBetween: 40 },
                            },
                        });
                    });
                };
                "requestIdleCallback" in window ? window.requestIdleCallback(start) : start();
                i.disconnect();
            }
        },
        { rootMargin: "200px" }
    ).observe(e);
}
initTopSellerSwiper();
